// SidebarContext.js
import { createContext, useState, useContext } from 'react';
import PropTypes from "prop-types";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isToggled, setIsToggled] = useState(true);
  const [isHovered, setIsHovered] = useState(true);

  const toggleSideMenu = () => {
    setIsToggled(!isToggled);
    document.querySelector('.app').classList.toggle('sidenav-toggled');
  };

  const Onhover = () => {
    if (document.querySelector(".app")?.classList.contains("sidenav-toggled")) {
      document.querySelector(".app").classList.add("sidenav-toggled-open");
    }
    setIsHovered(true);
  };

  const Outhover = () => {
    document.querySelector(".app")?.classList.remove("sidenav-toggled-open");
    setIsHovered(false);
  };

  return (
    <SidebarContext.Provider value={{  isToggled, isHovered, toggleSideMenu, Onhover, Outhover }}>
      {children}
    </SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export default SidebarContext;
